export default "__VITE_ASSET__YotfTaC5__"